// This is a build-time switch. The demo is deployed as a separate Worker so
// public requests can never select the production API by changing a URL.
export const demoMode = import.meta.env.VITE_DEMO_MODE === "true";
